module.exports = __webpack_public_path__ + "static/media/OOCL.633be9b7.svg";